import { render, staticRenderFns } from "./Sustainable.vue?vue&type=template&id=5c98533b"
import script from "./Sustainable.vue?vue&type=script&lang=js"
export * from "./Sustainable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports